export default __webpack_public_path__ + "static/media/pause.f6d970a0.svg";